//framework
import React, { memo } from "react";
import PropTypes from "prop-types";

//styles
import styles from "./ConnectingOverlay.module.scss";

//components
import GameCityLoading from "components/Shared/GameCityLoading/GameCityLoading";

//services
import { getCachedBillboardUrl } from "services/loadingConfig";

// backgroundImage is accepted for backwards compatibility but no longer used —
// the overlay always shows the Game City branded loading scene. The billboard
// comes from the cached admin loading-config (refreshed by Preloader on every
// page load); when null, GameCityLoading shows no billboard at all.
const ConnectingOverlay = memo(function ConnectingOverlay({ show = false, text = "Connecting you to the game", backgroundImage, large = false }) {
    return (
        <div className={`${styles.overlay} ${show ? styles.show : ""}`} aria-hidden={!show} aria-busy={show} role="status" >
            <GameCityLoading text={text} large={large} billboardSrc={getCachedBillboardUrl() || undefined} />
        </div>
    );
});

ConnectingOverlay.propTypes = {
    show: PropTypes.bool.isRequired,
    text: PropTypes.string,
    backgroundImage: PropTypes.string,
    large: PropTypes.bool,
};

export default ConnectingOverlay;
